import { Input } from 'cdk-radial';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  label {
    height: 2.2rem;
  }
`;
